import React from "react";

export default function Divider({ className = "" }: { className?: string }) {
  return <div className={`h-px bg-zinc-100 my-5 ${className}`} />;
}
